import {BarChart, ChartType, LineChart, MapChart, ScatterplotChart} from "@thinknum/d3-charts";
import {baseHostingURL} from "lib/config";
import {deserializeConfig} from "lib/serialization";

(window as any).embedChart = (id, compact) => {
  const elemId = `embed_chart_${id}`;
  const dataId = `embed_data_${id}`;

  const height = compact ? 80 : 350;
  document.write(`<div id="${elemId}" style="height: ${height}px;"></div>`);
  document.write(`<script id="${dataId}" src="${baseHostingURL}/${id}.js"></script>`);

  document.getElementById(dataId).addEventListener('load', () => {
    const config = deserializeConfig(window[dataId]);

    if (compact) {
      config.wantsCompact = true;
      config.wantsAxis = false;
    }

    const el = document.getElementById(elemId);

    if (config.size && config.size.height) {
      el.style.height = `${config.size.height + 50}px`;
    }

    if (config.type === ChartType.LINE) {
      const chart = new LineChart(config, el);
    } else if (config.type === ChartType.MAP) {
      const chart = new MapChart(config, el);
      document.getElementById(elemId).style.height = "500px";
    } else if (config.type === ChartType.BAR) {
      const chart = new BarChart(config, el);
    } else if (config.type === ChartType.SCATTERPLOT) {
      const chart = new ScatterplotChart(config, el);
    }
  });
};
